import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { selectListItems } from "../../../../../../redux/library/selector";
import { settings } from "../../../../../../redux/settings/actions";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import { selectAdminLevelTwoCreatedItem, selectAdminLevelTwoDeletedItem, selectAdminLevelTwoListItems, selectAdminLevelTwoUpdatedItem } from "../../../../../../redux/admin-level-two/selector";
import { adminLevelTwo } from "../../../../../../redux/admin-level-two/action";
import { selectAdminLevelCityListItems } from "../../../../../../redux/city/selector";
import { adminLevelCity } from "../../../../../../redux/city/action";
const GlobalCities = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const result = useSelector(selectCurrent)
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const [categoriesComparisonData, setCategoriesComparisonData] = useState<any>();
    const [categoriesListData, setAdminLevelOneListData] = useState<any>();
    const [uploadFor, setUploadFor] = useState('create');
    const [showComparisonPopup, setShowComparisonPopup] = useState<boolean>(false);
    const { header, footer, currency } = result
    const libraryData = useSelector(selectListItems)
    const listGlobalAdminLevelTwoData = useSelector(selectAdminLevelCityListItems)
    const createAdminLevelOneData = useSelector(selectAdminLevelTwoCreatedItem)
    const compareAdminLevelOneData = useSelector(selectAdminLevelTwoCreatedItem)
    const updateAdminLevelOneData = useSelector(selectAdminLevelTwoUpdatedItem)
    const deleteAdminLevelOneData = useSelector(selectAdminLevelTwoDeletedItem)
    const [columnDefs, setColumnDefs] = useState({});
    const [searchCriteriaList, setSearchCriteriaList] = useState<any>([]);

    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: "Sl",
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: "Sl",
                cellRenderer(params: any) {
                    return parseInt(params.node.id, 10) + 1;
                },
            },

           {
    field: "GlobalAdminLayer1Name",
    headerName: "Country",
    searchField: "GlobalAdminLayer1Name",
    sortable: true,
    filter: true,
    filterType: "text",
},
{
    field: "GlobalAdminLayer2Name",
    headerName: "State",
    searchField: "GlobalAdminLayer2Name",
    sortable: true,
    filter: true,
    filterType: "text",
},
{
    field: "GlobalAdminLayer3Name",
    headerName: "District",
    searchField: "GlobalAdminLayer3Name",
    sortable: true,
    filter: true,
    filterType: "text",
},
{
    field: "GlobalAdminLayer4Name",
    headerName: "City",
    searchField: "GlobalAdminLayer4Name",
    sortable: true,
    filter: true,
    filterType: "text",
},
{
    field: "Name",
    headerName: "Area Name",
    searchField: "Name",
    sortable: true,
    filter: true,
    filterType: "text",
},
{
    field: "Code",
    headerName: "Code",
    searchField: "Code",
    sortable: true,
    filter: true,
    filterType: "text",
},
        ]);
    };

    const fetchadminLevelTwo = async () => {
        await dispatch(adminLevelCity.resetAction({ actionType: 'list' }))
        await dispatch(adminLevelCity.list({
            url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-nexus-cloud/geo-coverage/cities/fetch`,
            entity: 'adminLevelCity',
            jsonData:
            {
                "Context": {},
                "Records": [
                    {}
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "GlobalCityId",
                    "SortOrder": "desc"
                }
            }
        }))
    }

    const handleAdd = () => {
        navigate(`${0}`)
    }

    const handleSelect = (data: any) => {
    }

    const handleEdit = (data: any) => {
        navigate(`${data.GlobalCityId}`)
    }

    const handleSearch = async (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column || data?.searchCriteriaList,
                FieldText: data?.column || data?.searchCriteriaList,
                FieldType: 'text',
                FilterOperatorId: data?.filterOperatorId || 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }
        await dispatch(adminLevelCity.resetAction({ actionType: 'list' }))
        await dispatch(adminLevelCity.list({
            url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-nexus-cloud/geo-coverage/cities/fetch`,
            entity: 'adminLevelCity',
            jsonData:
            {
                "Context": {},
                "Records": [
                    {}
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "GlobalDBNDomainId",
                    "SortOrder": "desc",
                    "Searches": searchCriteria,
                }
            }
        }));
    }


    const additionButtons: any = [
        {
            name: (
                <div className="flex items-center gap-2">
                    {/* Plus Icon */}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path
                            d="M12 5V19M5 12H19"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            ),
            callback: () => handleAdd(),
        },
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload this table</title>
                    <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            // name: 'Reload',
            callback: () => handleReloadData(),
        },
    ];

    const handleReloadData = () => {
        fetchadminLevelTwo();
    }

    const handleUploadCategoriesClick = () => {
        setUploadFor('create')
        dispatch(settings.set({ getUploadModal: 'open' }))
    };

    const handleCompareCategoriesClick = () => {
        setUploadFor('compare')
        dispatch(settings.set({ getUploadModal: 'open' }))
    };


    const handleDelete = async (data: any) => {
        await dispatch(adminLevelCity.resetAction({ actionType: 'delete' }))
        await dispatch(adminLevelCity.delete({
            url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-nexus-cloud/geo-coverage/cities/delete`,
            entity: 'adminLevelCity',
            jsonData: {
                Context: {},
                Records: [
                    {
                        Id: data?.GlobalCityId

                    }
                ]
            }
        })).then(() => {
            fetchadminLevelTwo();
        });
    }


    useEffect(() => {
        const searchCriteria: any = listGlobalAdminLevelTwoData?.result?.items
            ?.filter((item: any) => item?.Message?.SpecificationAttributeName) // Filter out items with falsy SpecificationAttributeName
            ?.map((item: any) => ({
                FieldName: item.Message.SpecificationAttributeName,
            }));
        setSearchCriteriaList(searchCriteria)
    }, [listGlobalAdminLevelTwoData]);

    useEffect(() => {
        if (listGlobalAdminLevelTwoData?.isSuccess) {
            setAdminLevelOneListData(listGlobalAdminLevelTwoData)
            dispatch(adminLevelTwo.resetAction({ actionType: 'list' }))
        }
    }, [listGlobalAdminLevelTwoData]);

    useEffect(() => {
        if (createAdminLevelOneData?.isSuccess) {
            dispatch(adminLevelTwo.resetAction({ actionType: 'create' }))
            fetchadminLevelTwo();
            toast.info('Routing Model created successfully.')
        }
    }, [createAdminLevelOneData]);

    useEffect(() => {
        if (updateAdminLevelOneData?.isSuccess) {
            dispatch(adminLevelTwo.resetAction({ actionType: 'update' }))
            toast.info('Routing Model updated successfully.')
        }
    }, [updateAdminLevelOneData]);

    useEffect(() => {
        if (deleteAdminLevelOneData?.isSuccess) {
            dispatch(adminLevelTwo.resetAction({ actionType: 'delete' }))
            toast.info('Routing Model deleted successfully.')
        }
    }, [deleteAdminLevelOneData]);

    useEffect(() => {
        if (compareAdminLevelOneData?.isSuccess) {
            setCategoriesComparisonData(compareAdminLevelOneData)
            setShowComparisonPopup(true)
            dispatch(listGlobalAdminLevelTwoData.resetAction({ actionType: 'uploadCompare' }))
            // toast.info('Comparison completed successfully.')
        }
    }, [compareAdminLevelOneData]);

    useEffect(() => {
        createColumnDefs()
        fetchadminLevelTwo()
        setShowComparisonPopup(false)
        dispatch(adminLevelTwo.resetAction({ actionType: 'create' }))
        dispatch(adminLevelTwo.resetAction({ actionType: 'uploadCreate' }))
        dispatch(adminLevelTwo.resetAction({ actionType: 'uploadCompare' }))
        dispatch(adminLevelTwo.resetAction({ actionType: 'update' }))
        dispatch(adminLevelTwo.resetAction({ actionType: 'delete' }))
    }, [pageData, pageSize])

    return (
        <>

            {listGlobalAdminLevelTwoData?.isLoading ||
                createAdminLevelOneData?.isLoading ||
                updateAdminLevelOneData?.isLoading ||
                deleteAdminLevelOneData?.isLoading ||
                compareAdminLevelOneData?.isLoading ? <PageLoader /> :
                <Table
                    columnData={columnDefs}
                    rowData={categoriesListData?.result?.items}
                    enableFilter={true}
                    setPageData={setPageData}
                    setPageSize={setPageSize}
                    paginationData={categoriesListData?.result?.pagination}
                    onSearch={handleSearch}
                    searchCriteriaList={searchCriteriaList}
                    onSelect={handleSelect}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    additionButtons={additionButtons}
                    checkboxConfig={{
                        allowMultiSelect: true,
                        defaultSelectedIds: [],
                        isDisabled: false,
                        keyColumn: 'GlobalCityId',
                    }}
                    headingName="Global City"
                />
            }
        </>
    );
};

export default GlobalCities;

